import { FC, useState, useCallback, useRef, ChangeEventHandler, KeyboardEvent } from "react";
import { useDispatch } from "react-redux";
import ReactDOM from "react-dom";

import Button from "./../../../libs/Button";
import { IconTypes } from "./../../../libs/Icon";
import { CollaboratorRole } from "./../../../store/collaborators/types";
import { addCollaborator } from "../../../store/collaborators/actionCreators";
import Dropdown from "./../Dropdown";

import styles from "./styles.module.scss";

const Header: FC = () => {
    const dispatch = useDispatch();

    const [areControlsVisible, setAreControlsVisible] = useState<boolean>(false);
    const [email, setEmail] = useState<string>("");
    const [currentRole, setCurrentRole] = useState<CollaboratorRole>(CollaboratorRole.Editor);

    const formRef = useRef<HTMLDivElement>(null);

    const handleFocus = useCallback(() => {
        if (areControlsVisible === false) setAreControlsVisible(true);
    }, [areControlsVisible]);

    const handleBlur = useCallback(
        ({ relatedTarget }) => {
            if (
                !(
                    relatedTarget === formRef.current || ReactDOM.findDOMNode(formRef.current)?.contains(relatedTarget)
                ) &&
                email.trim() === ""
            )
                setAreControlsVisible(false);
        },
        [formRef, email],
    );

    const handleEmailChange: ChangeEventHandler<HTMLInputElement> = useCallback(e => {
        setEmail(e.target.value);
    }, []);

    const handleCollaboratorCreate = () => {
        if (email.trim() !== "") {
            dispatch(
                addCollaborator({
                    email,
                    role: currentRole,
                }),
            );
            setEmail("");
        }
    };

    const onEnter = (e: KeyboardEvent<HTMLInputElement>) => {
        if (e.keyCode === 13) {
            e.preventDefault();
            handleCollaboratorCreate();
        }
    };

    const onChange = (newValue: CollaboratorRole) => {
        setCurrentRole(newValue);
    };

    const dropdownIcon = currentRole === CollaboratorRole.Editor ? IconTypes.EDIT : IconTypes.EYE;

    return (
        <header className={styles.header}>
            <p>Share form with collaborators for edit and view</p>

            <div ref={formRef}>
                <input
                    name="email"
                    placeholder="Example@example.com"
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    onChange={handleEmailChange}
                    onKeyDown={onEnter}
                    value={email}
                />
                {areControlsVisible && (
                    <>
                        <div className={styles.inputActions}>
                            <Button type="button" icon={IconTypes.CLOSE} iconSize={20} onBlur={handleBlur} />

                            <hr />

                            <Dropdown
                                iconSize={20}
                                icon={dropdownIcon}
                                className={styles.edit}
                                currentRole={currentRole}
                                onChange={onChange}
                                onBlur={(relatedTarget: null | FocusEvent["relatedTarget"]) =>
                                    handleBlur({ relatedTarget })
                                }
                            />
                        </div>

                        <Button
                            type="button"
                            big={false}
                            text="Send"
                            onBlur={handleBlur}
                            onClick={handleCollaboratorCreate}
                        />
                    </>
                )}
            </div>
        </header>
    );
};

export default Header;
